import { render } from "./MethodAssessmentSchemaPage.vue?vue&type=template&id=18018eae"
import script from "./MethodAssessmentSchemaPage.vue?vue&type=script&lang=js"
export * from "./MethodAssessmentSchemaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__